import { useEffect, useState } from "react";
import "../../assets/css/agent.scss";
import logoBlue from "../../assets/images/logo_blue.png";
import ProductAuthModal from "../../components/modal/product_auth_modal";
import { useNavigate, useSearchParams } from "react-router-dom";

function AgentPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const navigate = useNavigate();
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);

  const handleProductAuthSuccess = (phoneNumber) => {
    navigate(`/agent/register?kd_business=${kdBusiness}`, {
      state: { phoneNumber: phoneNumber },
    });

    setIsProductModalOpen(false);
  };

  useEffect(() => {
    if (!kdBusiness) {
      navigate(-1);
    }
  }, [kdBusiness]);

  return (
    <div className="agent-container">
      <main className="agent-main">
        <div className="agent-content">
          <div className="logo-section">
            <div className="logo-text">
              <img src={logoBlue} alt="" />
            </div>
          </div>

          <div className="hero-section">
            <h1 className="main-title">에이전트 관리자</h1>
            <p className="subtitle">새로운 에이전트를 등록하고 관리하세요</p>

            <button
              className="register-button"
              onClick={() => {
                setIsProductModalOpen(true);
              }}
            >
              에이전트 등록하기
            </button>
          </div>
        </div>
      </main>
      <ProductAuthModal
        isOpen={isProductModalOpen}
        onClose={() => setIsProductModalOpen(false)}
        onSuccess={handleProductAuthSuccess}
      />
    </div>
  );
}

export default AgentPage;
